import { render } from "./connection.vue?vue&type=template&id=0150bcc3&scoped=true"
import script from "./connection.vue?vue&type=script&lang=js"
export * from "./connection.vue?vue&type=script&lang=js"

import "./connection.vue?vue&type=style&index=0&id=0150bcc3&lang=scss&scoped=true"
import "./connection.vue?vue&type=style&index=1&id=0150bcc3&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0150bcc3"]])

export default __exports__